import React from "react";

const LOGO_URL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_forward-ai--1klw9yfr/artifacts/46be3ed2bd13d68d_MayForwardTechLogo.webp";

export const Wordmark = ({ dark = false }) => (
  <img
    src={LOGO_URL}
    alt="May Forward Tech — Never go straight, always go forward."
    className={
      dark
        ? "h-14 w-auto rounded-lg bg-white px-3 py-1.5"
        : "h-10 w-auto"
    }
  />
);
